import React from 'react'
const req = require.context('../Icon', true, /^(.*\.(js$))[^.]*$/im)

const getName = key => {
  const matches = /\.\/(\w+)\.js/gi.exec(key)
  return matches && matches.length && matches[1]
}
const Icons = req
  .keys()
  .filter(key => key && key !== './Icon.js')
  .map(key => {
    return {
      key: getName(key),
      component: req(key).default
    }
  })

const IconsPreview = () => {
  return (
    <div className='icons-preview__container'>
      <h1 className='icons-preview__title'>Icons preview</h1>
      <h2 className='icons-preview__subtitle'>
        This is a display of all the icons in the app, it's visible only on the
        development version.<br />
        They're resized to keep the layout from breaking.
      </h2>
      <br />
      <br />
      <div className='icons-preview__table'>
        {Icons.map(icon => {
          return (
            <div key={icon.key} className='icons-preview__item'>
              <div className='icons-preview__name'>
                {'<'}
                {icon.key}
                {'/>'}
              </div>
              <div className='icons-preview__icon'>
                <icon.component />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default IconsPreview
